import PropTypes from "prop-types";
import Link from "next/link";
import Button from "components/shared/button/Button";
import Tooltip from "../tooltip/Tooltip";

import {
    BalanceContainer,
    Section,
    DataField,
    Label,
    Data
} from "./Balance.styled";

function Balance({ value, date }) {
    const formatDate = new Date(date)
        .toLocaleDateString("nl-NL")
        .replace(/\//g, "-");

    return (
        <BalanceContainer>
            <Section>
                <DataField>
                    <Label>Kaartsaldo</Label>
                    <Data>{`€${value}`}</Data>
                </DataField>
                <DataField>
                    <Label>Vervaldatum</Label>
                    <Data>
                        {formatDate}
                        <Tooltip />
                    </Data>
                </DataField>
            </Section>
            <Section>
                <Link passHref href="/inwisselen">
                    <Button element="a">inwisselen</Button>
                </Link>
            </Section>
        </BalanceContainer>
    );
}

Balance.propTypes = {
    value: PropTypes.number.isRequired,
    date: PropTypes.string.isRequired
};

export default Balance;
